// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getQueryString = (params: Record<string, any>): string => {
  const qs: string[] = []

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const append = (key: string, value: any) => {
    qs.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const process = (key: string, value: any) => {
    if (value !== undefined && value !== null) {
      if (Array.isArray(value)) {
        value.forEach((v) => {
          process(`${key}[]`, v)
        })
      } else if (typeof value === 'object') {
        Object.entries(value).forEach(([k, v]) => {
          process(`${key}[${k}]`, v)
        })
      } else {
        append(key, value)
      }
    }
  }

  Object.entries(params).forEach(([key, value]) => {
    process(key, value)
  })

  if (qs.length > 0) {
    return `?${qs.join('&')}`
  }

  return ''
}
